/*!
 * Swiper
 * use : swiper-buldle.js
 */

function swiperAddPagination(target, addClass) {
  document.querySelectorAll(target).forEach((element) => {
    element.insertAdjacentHTML(
      "beforeend",
      '<div class="swiper-pagination ' + addClass + '"></div>'
    );
  });
}

function swiperAddButton(target, position, addClassNext, addClassPrev) {
  document.querySelectorAll(target).forEach((element) => {
    element.insertAdjacentHTML(
      position,
      '<div class="is-next ' +
        addClassNext +
        '"></div>' +
        '<div class="is-prev ' +
        addClassPrev +
        '"></div>'
    );
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const targetClass = ".swiper-product-image .M_imageMainWrap";

  document.querySelectorAll(".swiper .M_imageMainList").forEach((element) => {
    element.classList.add("swiper-wrapper")
  });
  document.querySelectorAll(".swiper .M_imageMainList-item").forEach((element) => {
    element.classList.add("swiper-slide")
  });


  const thumb = document.querySelectorAll(".swiper-product-image-thumbnail .M_imageMainList-item");

  // append button
  swiperAddButton(
    targetClass,
    "beforeend",
    "swiper-button-next",
    "swiper-button-prev"
  );
  const thumbsSwiper = new Swiper(".swiper-product-image-thumbnail .M_imageMainWrap", {
    slidesPerView: 4,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    allowTouchMove:false
  });

  const swiper = new Swiper(targetClass, {
    cssMode: true,
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    speed: 3000,
    navigation: {
      nextEl: ".is-next",
      prevEl: ".is-prev",
    },
    thumbs: {
      swiper: thumbsSwiper
    }
  });
});
